module.exports = __webpack_public_path__ + "img/name-img.86cd12fb.png";